import * as React from 'react';
import * as vars from '../../consts/variables';
import { hasSoldOut, priceAvailability } from '../../helpers/priceHelpers';
import { __ } from '../../helpers/TranslationService';
import { ICabinInfo, ISoldOutBooking } from '../../interfaces';
import { CTA } from '../CTA';
import { Link } from '../Link';
import { PerPersonPriceSmall } from '../PerPersonPriceSmall';

const styles: Record<string, React.CSSProperties> = {
    wrapper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginTop: 'auto',
        marginLeft: 'auto',
        maxWidth: '200px',
    },
    priceComponentStyle: {
        color: vars.black,
        width: 'auto',
        marginBottom: 10,
    },
    button: {
        fontSize: 14,
    },
};

interface IProps {
    url: string;
    perPersonPrice: number;
    discountPercentage: number;
    currency: string;
    isButtonShown: boolean;
    departure: number;
    soldOutBooking: ISoldOutBooking;
    discountThreshold: number;
    cabin?: ICabinInfo;
    nPassengers?: number;
}

export function CabinPriceSection(props: IProps) {
    const price = priceAvailability(
        props.departure,
        props.soldOutBooking,
        props.perPersonPrice,
        props.currency,
        props.cabin,
        props.nPassengers,
    );
    const isDisabled = hasSoldOut(props.departure, props.soldOutBooking, props.perPersonPrice);

    return (
        <div style={styles.wrapper}>
            <PerPersonPriceSmall
                price={props.perPersonPrice}
                priceString={price.string}
                discount={props.discountPercentage}
                wrapperStyle={styles.priceComponentStyle}
                discountThreshold={props.discountThreshold}
                onRequest={!price.valid}
            />
            {props.isButtonShown && !isDisabled && (
                <CTA>
                    <Link style={styles.button} href={props.url} mask={true}>
                        {__('Request cruise now', 'dreamlines')}
                    </Link>
                </CTA>
            )}
        </div>
    );
}
